// Single row in MarketplaceRegistrarDomainPicker's ResultsList.
// One child per `searchResults[]` entry. Shape:
//   { domain: 'example.com', available: true, priceUsd?: 12, currencyCode?: 'USD' }
//
// Available domains show price + [Register] button; taken domains show
// "taken" muted text. Per MARKETPLACE tick-7 spec; INTEGRATIONS scaffolds.

export const MarketplaceRegistrarSearchResult = {
  flow: 'x',
  align: 'center space-between',
  gap: 'Z',
  padding: 'Y Z',
  borderRadius: 'Y',
  // Fill-contrast row (was `border: 'hairline solid line'` — border-habit
  // sweep, design-direction.md §8) — the row's own `document` fill already
  // separates it from the picker's `layer`-washed container.
  background: 'document',

  Status: {
    tag: 'span',
    fontSize: 'A',
    text: (el) => (el.parent.available ? '✓' : '✗'),
    color: (el) => (el.parent.available ? 'green' : 'caption')
  },

  Domain: {
    tag: 'span',
    flex: '1',
    fontSize: 'Z2',
    fontWeight: '500',
    color: 'title',
    text: (el) => el.parent.domain || ''
  },

  Price: {
    tag: 'span',
    fontSize: 'Y2',
    color: 'caption',
    hide: (el) => !el.parent.available,
    text: (el) => {
      const p = el.parent.priceUsd
      if (p == null) return ''
      const cur = el.parent.currencyCode || 'USD'
      return cur === 'USD' ? `$${p}/yr` : `${p} ${cur}/yr`
    }
  },

  TakenLabel: {
    tag: 'span',
    fontSize: 'Y2',
    color: 'caption',
    hide: (el) => el.parent.available,
    text: '{{ publish.domains.taken | polyglot }}'
  },

  RegisterBtn: {
    extends: 'Button',
    hide: (el) => !el.parent.available,
    // Register action — routes through the same capability layer.
    // `callCapabilityAndSet` is shipped by MARKETPLACE in
    // `marketplace/functions/index.js` (helper signature takes state
    // as the last arg — MARKETPLACE tick-9 fix).
    onClick: (e, el, s) =>
      el.call(
        'callCapabilityAndSet',
        'registering',
        'registerResult',
        'registerError',
        'domain.register',
        { domain: el.parent.domain },
        s
      ),
    text: '{{ publish.domains.register | polyglot }}'
  }
}
